import PropTypes from "prop-types";
import CountryUtil from "shared/src/uidispatcherapi/CountryUtil";
import * as React from "react";
import * as _ from "lodash";
import { Link } from "react-router";
import { connect } from "shared/src/stores/storeConnect";
import { withReactAdapter } from "shared/src/module-federation/withReactAdapter";
import MainCategoryStore from "../../../stores/MainCategoryStore";
import SearchResult from "../shared/article-badges/SearchResult";
import SearchStore from "../../../stores/SearchStore";
import SearchAction from "../../../actions/SearchAction";
import PageWrapper from "../../general/PageWrapper";
import * as SearchUtil from "../../../utils/SearchUtil";
import { SearchQuery, Query } from "shared/src/types/articlesearch/SearchResult";
import { Category } from "shared/src/types/articlesearch/Category";
import { determineCategorySearchProfile } from "../../../utils/determineSearchProfile";
import SessionStore from "shared/src/stores/SessionStore";
import { shouldShowSubcategoriesPanelOnCategoryPages } from "../../../searchdiscover/toggles";
import { CategoryContentPanel } from "./CategoryContentPanel";
import { getComponentByName } from "shared/src/components/LazyWrapper";
const Banner = getComponentByName("cia_ui/Banner");
const LoginPrompt = getComponentByName("cia_ui/LoginPrompt");

function CategoryPageLink(props: { query: SearchQuery; children: any }) {
    const otherProps = _.omit(props, ["query", "children"]);
    return (
        <Link to={SearchUtil.createLocationForCategoryPage(props.query)} {...otherProps}>
            {props.children}
        </Link>
    );
}

type CategoryPageProps = {
    params: {
        splat: string;
    };
    location: {
        query: Query;
        pathname: string;
        state:
            | {
                  [x: string]: any;
              }
            | undefined
            | null;
    };
    customerStore: string | undefined | null;
    categoriesLoaded: boolean | undefined | null;
};

type State = {
    categoryId: string | undefined | null;
    name: string;
    categoryPath: string[];
    category: Category | undefined | null;
    bannerShown: boolean;
};

export class CategoryPage extends React.Component<CategoryPageProps, State> {
    static contextTypes = {
        router: PropTypes.object.isRequired
    };

    state = this.getStateFromStore(this.props.params.splat);

    getStateFromStore(category: string) {
        const categories = MainCategoryStore.getCategories().categories;
        if (categories) {
            const myCat = MainCategoryStore.getCategoryForId(category);
            const path = MainCategoryStore.getCategoryPathForId(category);
            return {
                name: (myCat && myCat.name) || "",
                categoryId: myCat && myCat.categoryId,
                categoryPath: path,
                category: myCat,
                bannerShown: false
            };
        } else {
            return {
                categoryPath: [],
                categoryId: null,
                name: "",
                category: null,
                bannerShown: false
            };
        }
    }

    componentWillReceiveProps(nextProps: CategoryPageProps) {
        SearchAction.query.trigger(this.buildQuery(nextProps), nextProps.location.state);
        const newState = this.getStateFromStore(nextProps.params.splat);
        if (!_.isEqual(newState, this.state)) {
            this.setState(newState);
        }
        this.checkRedirect(nextProps);
    }

    componentWillMount() {
        MainCategoryStore.loadMainCategories();
        SearchAction.query.trigger(this.buildQuery(this.props), this.props.location.state);
        this.checkRedirect(this.props);
    }

    componentDidMount(): void {
        SearchUtil.clearSecondQInURL();
    }

    componentDidUpdate(): void {
        SearchUtil.clearSecondQInURL();
    }

    getFullPageBanner = (onBannerLoaded: () => void) => {
        if (this.state.categoryId) {
            return (
                <Banner
                    page="categoryPage"
                    type="fullPageBanner"
                    targetParams={{
                        categoryId: this.state.categoryId,
                        categoryPathId: _.map(this.state.categoryPath, (cat) => (cat && cat.categoryId) || "")
                    }}
                    onBannerLoaded={onBannerLoaded}
                />
            );
        }
        return null;
    };

    getArticleTeaserBanner = () => {
        return (
            <Banner
                page="categoryPage"
                type="articlesTilesTeaser"
                targetParams={{
                    categoryId: this.state.categoryId,
                    categoryPathId: _.map(this.state.categoryPath, (cat) => (cat && cat.categoryId) || "")
                }}
            />
        );
    };

    buildQuery = (props: CategoryPageProps): SearchQuery => {
        const sanitizedLocation = SearchUtil.sanitizeQuery(props.location);
        return SearchUtil.mergeSearchQueries(
            SearchUtil.buildQuery(sanitizedLocation.query, SearchStore.categoryPurpose),
            {
                categoryPath: props.params.splat,
                profile: determineCategorySearchProfile()
            }
        );
    };

    changeQuery = (newQuery: SearchQuery) => {
        this.context.router.replace(SearchUtil.createLocationForCategoryPage(newQuery));
    };

    checkRedirect = (props: CategoryPageProps) => {
        const myCat = MainCategoryStore.getCategoryForId(props.params.splat);
        // We change the URL and have to redirect if
        // - we entered the ugly one (with the non-ascii separator) to the pretty category url if
        // - we have not found the desired URL, but can guess better than the notfound page
        if (myCat && myCat.urlCategoryPath !== props.params.splat) {
            this.context.router.replace("/category/" + myCat.urlCategoryPath);
        } else if (props.categoriesLoaded && !myCat) {
            this.context.router.replace("/notfound");
        }
    };

    onBannerLoaded = () => {
        this.setState({ bannerShown: true });
    };

    render() {
        const headline = this.state.name;
        const pageName = "category";
        return (
            <PageWrapper
                vertical="searchdiscover"
                // Note: We explicitly do not pass the location to the pagewrapper, since we do not want the query to appear
                // in the 'global & general' search field
                title="EX_CATEGORY_SEARCH_DOCUMENT_TITLE"
                pageName={pageName}
                disableFallbackTracking
                location={SearchUtil.sanitizeQuery(this.props.location)}
                scrollPositionResetBasedOn={this.props.params.splat}
                additionalParamsForTitle={{ name: headline }}
                metaDescription="EX_CATEGORY_SEARCH_DOCUMENT_META_DESCRIPTION"
                additionalParamsForMetaDescription={{ name: headline }}>
                <SearchResult
                    headline={headline}
                    trackingHeadline={{ type: "text", text: headline }}
                    fullPageBanner={this.getFullPageBanner(this.onBannerLoaded)}
                    subcategoryPanelConfig={{
                        show: shouldShowSubcategoriesPanelOnCategoryPages(),
                        lines: this.state.bannerShown ? 1 : 2
                    }}
                    articleTeaserBanner={this.getArticleTeaserBanner()}
                    location={SearchUtil.sanitizeQuery(this.props.location)}
                    doNotShowAllCategoriesLink
                    query={this.buildQuery(this.props)}
                    queryLinkComponent={CategoryPageLink}
                    onChangeQuery={this.changeQuery}
                    pageClass={"body ex-category-page"}
                    pageType={"CATEGORY"}
                    pageName={pageName}
                />
                <LoginPrompt pageName="category" container={this} />
                {CountryUtil.getOptionalConfig()?.showCategoryContent && <CategoryContentPanel />}
            </PageWrapper>
        );
    }
}

const wrapped = connect(
    {
        stores: [
            [MainCategoryStore, (s: typeof MainCategoryStore) => ({ categoriesLoaded: s.hasResults() })],
            [SessionStore, ["customerStore"]]
        ]
    },
    CategoryPage
);

export default withReactAdapter(wrapped) as any;
